var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9559 4.16846H3.53908C2.22739 4.16846 1.16406 5.23179 1.16406 6.54348V17.6269C1.16406 18.9386 2.22739 20.0019 3.53908 20.0019H20.9559C22.2676 20.0019 23.3309 18.9386 23.3309 17.6269V6.54348C23.3309 5.23179 22.2676 4.16846 20.9559 4.16846Z",
    fill: "#ECECEC",
    stroke: "#ECECEC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70312 4.16669V2.58335C6.70312 2.16342 6.86994 1.76069 7.16688 1.46375C7.46381 1.16682 7.86654 1 8.28647 1H16.2032C16.6231 1 17.0259 1.16682 17.3228 1.46375C17.6197 1.76069 17.7865 2.16342 17.7865 2.58335V4.16669",
    stroke: "#ECECEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3309 9.70667H1.16406",
    stroke: "#29B191",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6381 10.0476V11.4048C15.6381 11.5247 15.5964 11.6398 15.5221 11.7246C15.4479 11.8095 15.3472 11.8571 15.2422 11.8571H9.70052C9.59554 11.8571 9.49486 11.8095 9.42063 11.7246C9.34639 11.6398 9.30469 11.5247 9.30469 11.4048V10.0476",
    stroke: "#29B191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbBookingIcon);
export default __webpack_public_path__ + "static/media/SBBookingIcon.a87aee3c8400be4a2bf2a8304b7fa299.svg";
export { ForwardRef as ReactComponent };